export const getDescendent = (obj: any, desc: string) => {
  return desc.split(".").reduce((a, b) => {
    if (b.includes("[")) {
      let index = parseInt(b.replace("[", "").replace("]", ""));
      return a?.[index];
    } else {
      return a?.[b];
    }
  }, obj);
};

export const getErrorElem = (content: any) => {
  return <p className="invalid-input-error">* {content}</p>;
};

export const getValidationErrors = (errors: any, field: string, label: string, rules: any, requiredError = "es requerido") => {
  let error = getDescendent(errors, field);

  if (error && error.type === "required") {
    return getErrorElem(`${label} ${requiredError}`);
  }

  if (error && error.type === "max") {
    return getErrorElem(`${label} debe ser igual o menor que ${rules.max}`);
  }

  if (error && error.type === "min") {
    return getErrorElem(`${label} debe ser igual o mayor que ${rules.min}`);
  }

  if (error && error.type === "maxLength") {
    return getErrorElem(`${label} solo debe tener maximo ${rules.maxLength} caracteres`);
  }

  if (error && error.type === "minLength") {
    return getErrorElem(`${label} debe tener minimo ${rules.minLength} caracteres`);
  }

  if (error && error.type === "pattern") {
    return getErrorElem(`${label} es invalido`);
  }
   if (error && error.type === "validate") {
    return getErrorElem(error.message || `${label} es inválido`);
  }

  return null;
};
